import React from 'react'
import { FloatingFilter } from '../../../components'
import { ListNav } from './index'
import { Featured } from './featured'
import qs from 'query-string'
import { useLocation } from 'react-router-dom'
import PaginatedList from './paginated-list'

const MainContentMobile = ({
  embed,
  events,
  defaultFeaturedItems,
  pageConfig,
  actions
}) => {
  const query = qs.parse(useLocation().search)

  return (
    <div>
      {
        embed ? (
          <div className="container mx-auto">
            <ListNav embed={embed}/>
          </div>
        ) : <ListNav />
      }
      {
        Object.keys(query).length === 0 &&
        <Featured embed={embed} defaultItems={defaultFeaturedItems}/>
      }
      <section className="container mx-auto">
        <PaginatedList
          query={query}
          events={events}
          pageConfig={pageConfig}
          actions={actions}
        />
      </section>
      <FloatingFilter />
    </div>
  )
}

export { MainContentMobile }
